/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CittadinoServizioDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface CittadinoServiziServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lista dei servizi attivi accessibili al cittadino.
     * Audience: CITTADINO. Servizi attivi dei bandi per cui il caller ha almeno una pratica accettata (RICHIESTA_ACCETTATA / VOUCHER_ASSEGNATI / VOUCHER_CONSEGNATI), distinct sul servizio. Lista non paginata, ordinata per codice bando ASC, data_inizio DESC.
     * @endpoint get /api/v1/cittadino/servizi
*/
    listServiziCittadino(extraHttpRequestParams?: any): Observable<Array<CittadinoServizioDTO>>;

}
